import * as React from 'react';
import { observer } from 'mobx-react';
import { createGlobalStyle } from 'styled-components';
import { AssetStore } from './stores';
import { computed } from 'mobx';

const fontFamilies = [
    'HeaderFont',
    'BodyFont',
    'FontLight',
    'FontLightItalic',
    'FontThin',
    'FontThinItalic',
    'FontMedium',
    'FontMediumItalic',
    'FontRegular',
    'FontItalic',
    'FontSemiBold',
    'FontSemiBoldItalic',
    'FontBold',
    'FontBoldItalic',
    'FontBlack',
    'FontBlackItalic',
];

interface GlobalStylesProps {
    assetStore?: AssetStore;
    children?: any;
}

@observer
class GlobalStyles extends React.Component<GlobalStylesProps> {
    @computed
    get StyledGlobalStyles() {
        return createGlobalStyle`
	* {
		box-sizing: border-box;
		margin: 0;
        padding: 0;
	}

    /*
     * Generate @font-face for fonts.
     * To make use of a particular font, upload a font file named e.g. "FontLight.ttf" to application assets,
     * then reference it in styles by font-family name e.g. "FontLight".
     * Fonts not referenced in styles will not be downloaded.
     */
    ${fontFamilies.map(font => {
        const { props } = this as any;
        if (props) {
            const { assetStore } = props;
            return `@font-face {
                        font-family: '${font}';
                        src: url('${assetStore.getAssetUrl(`${font}.ttf`)}');
                        font-display: fallback;
                    }`;
        }
    })}
        `;
    }

    render() {
        const { assetStore } = this.props;
        const StyledGlobalStyles = this.StyledGlobalStyles;
        return <StyledGlobalStyles assetStore={assetStore} />;
    }
}

export default GlobalStyles;



// WEBPACK FOOTER //
// ./src/GlobalStyles.tsx